import { default as NextLink, LinkProps as NextLinkProps } from "next/link";
import { LOCAL_DOMAIN, SITE_DOMAIN } from "@/shared/config/constants";
import { AnchorHTMLAttributes, ReactNode, RefAttributes } from "react";

export type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> &
  NextLinkProps & {
    children?: ReactNode;
  } & RefAttributes<HTMLAnchorElement>;

export const Link = ({ href, ...props }: LinkProps) => {
  const isDashboardLink = !!["/dashboard", "/orders", "/order"].find((link) => {
    if (String(href).startsWith(link) || String(href).startsWith(`https://app`)) return true;
  });

  let link = isDashboardLink
    ? String(href).startsWith("http")
      ? href
      : `https://app.${SITE_DOMAIN}${href}`
    : href;

  if (!String(link).startsWith("http") && String(link).startsWith("/")) {
    const suffix = href === "/" ? "" : href;
    link = LOCAL_DOMAIN ? `http://${LOCAL_DOMAIN}${suffix}` : `https://${SITE_DOMAIN}${suffix}`;
  }

  return <NextLink href={link} {...props} rel={isDashboardLink ? "nofollow" : props.rel} />;
};
